import api from '../../api';

export default function editBrand(brandId,data) {
  return api.patch(`/brands/manage/${brandId}`,data);
}